import React, { useEffect, useState } from "react";
import Preloader from "../elements/Preloader";
import HelmetReact from "../elements/HelmetReact";
import HeaderThree from "../components/HeaderThree";
import HeroThree from "../components/HeroThree";
import LogoSlider from "../components/LogoSlider";
import BenefitsSection from "../components/BenefitsSection";
import FooterThree from "../components/FooterThree";

const HomeThree = () => {
  let [active, setActive] = useState(true);

  useEffect(() => {
    setTimeout(function () {
      setActive(false);
    }, 500);
  }, []);

  return (
    <>
      {active === true && <Preloader />}

      <HelmetReact title={"Home"} />

      <HeaderThree />

      <HeroThree /> 
      
      <LogoSlider />


      <BenefitsSection />

      <FooterThree />
    </>
  );
};

export default HomeThree;